import Styles from './StreamsEnroll.module.scss';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Module imports.
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Typography from '@mui/material/Typography';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

// Components import.
import { useAPI } from 'components/lib';
import EnrollViewCard from 'components/global/EnrollViewCard/EnrollViewCard';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';

export function StreamsEnroll(props) {
    const [streamList, setStreamList] = useState([]);
    const [maxSelected, setMaxSelected] = useState(false);
    // eslint-disable-next-line
    const [selectedStreams, setSelectedStreams] = useState(new Set());
    const [resetSelections, setResetSelections] = useState(false);
    const { data, loading } = useAPI('api/streams', 'GET');

    const navigate = useNavigate();

    useEffect(() => {
        if (data?.length) {
            setStreamList(data);
        }
    }, [data]);

    function handleStreamSelection(streamId) {
        if (selectedStreams.has(streamId)) {
            selectedStreams.delete(streamId);
        } else {
            selectedStreams.add(streamId);
        }
        if (selectedStreams?.size === 4) {
            setMaxSelected(true);
        } else {
            setMaxSelected(false);
        }
    }

    function onEnroll() {
        const formData = {
            streamids: Array.from(selectedStreams),
        };
        if (!selectedStreams.size) {
            toast.dark(props.t('Streams.StreamsEnroll.toast.warn'), {
				type: 'error',
				position: 'top-right',
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
			return;
		}
        const options = {
            method: 'POST',
            url: `/api/streams/enroll`,
            headers: {
                accept: 'application/json',
            },
            data: formData,
        };
        axios
            .request(options)
            .then(function (response) {
                let status = response.status;
                if (status === 201) {
                    toast.dark(props.t('Streams.StreamsEnroll.toast.success'), {
                        type: 'success',
                        position: 'top-right',
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    navigate(`/streams`);
                } else {
                    toast.dark(props.t('Streams.StreamsEnroll.toast.error'), {
                        type: 'error',
                        position: 'top-right',
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    selectedStreams.clear();
                    setMaxSelected(false);
                    setResetSelections(true);
                }
            })
            .catch((err) => {
                let status = err.response.status;
                console.log('error', status);
                if (status === 406) {
                    toast.dark(props.t('Streams.StreamsEnroll.toast.exceed'), {
                        type: 'error',
                        position: 'top-right',
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    toast.dark(props.t('Streams.StreamsEnroll.toast.error'), {
                        type: 'error',
                        position: 'top-right',
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                selectedStreams.clear();
                setMaxSelected(false);
                setResetSelections(true);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
        setResetSelections(false);
    }

    return (
        <>
            <ToastContainer
                id="warning-toast"
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className={Styles.CardContainer}>
                <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                  <Typography
                      variant="h6"
                      sx={{ display: 'flex', gap: '16px', padding: '16px', color: 'rgb(0, 74, 173)' }}
                  >
                      <BreadCrumbs
                          onClickPaths={[
                              ''
                          ]}
                          crumbs={[

                              props.t('Streams.StreamsEnroll.breadcrumbs', { returnObjects: true })
                          ]}
                      />
                  </Typography>
                    <span style={{ display: 'flex', alignItems: "center", gap: "1rem" }}>
                        <a href='/streams' className={Styles.myLabsLink}>{props.t('Streams.StreamsEnroll.link')}</a>
                        <div id="enrollBtnContainer" className={Styles.enrollBtnContainer}>
                            <button
                                className={Styles.enrollButton}
                                onClick={() => {
                                    onEnroll();
                                }}
                            >
                                <AddCircleOutlineTwoToneIcon />
                                {props.t('Streams.StreamsEnroll.button')} </button>
                        </div>
                    </span>

                </div>
                {maxSelected && (
                    <Typography variant="h7" sx={{ display: 'flex', gap: '16px', padding: '16px', mb: '-15px', ml: '8px' }}>
                        {props.t('Streams.StreamsEnroll.subtitle')} </Typography>
                )}
                {loading ? (
                    <div>
                        <LoadingBackdrop isOpen={true} />
                    </div>
                ) : streamList.length > 0 ? (
                    streamList.map((stream) => (
                        <EnrollViewCard
                            data={stream}
                            key={stream.id}
                            handleStreamSelection={handleStreamSelection}
                            resetSelections={resetSelections}
                            maxSelected={maxSelected}
                        />
                    ))
                ) : (
                            <div style={{ paddingLeft: '22px' }}>{props.t('Streams.StreamsEnroll.message')}</div>
                )}

            </div>
        </>
    );
}
